// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2joIR","dragIcon":"SortableItem_dragIcon__2w49n","disabled":"SortableItem_disabled__2GUHR"};